import { RedditStandardEvents } from '@xyo-network/sdk-xyo-react-js';
class RedditEvents extends RedditStandardEvents {
}
export default RedditEvents;
//# sourceMappingURL=index.js.map